import { useState, useEffect, useCallback } from 'react';

// @context TGW-1769 サイドバーのチャンネル一覧取得。BEの general（仮想）+ channels[] を
//   単一配列に正規化して返す。全体は message_group_id を持たないため isGeneral で分岐させる。
export default function useChannels(circleId) {
  const [channels, setChannels] = useState([]);
  const [canManage, setCanManage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const normalize = (data) => {
    const general = {
      key: 'general',
      id: null,
      isGeneral: true,
      name: '全体',
      description: 'サークル全員のチャンネル',
      isPrivate: false,
      hasUnread: false,
      unreadMentionCount:
        (data.general && data.general.unread_mention_count) || 0,
      isMember: true,
      canLeave: false,
    };
    const rest = (data.channels || []).map((ch) => ({
      key: `ch-${ch.id}`,
      id: ch.id,
      isGeneral: false,
      name: ch.channel_name,
      description: ch.description,
      isPrivate: !!ch.is_private,
      hasUnread: !!ch.has_unread,
      unreadMentionCount: ch.unread_mention_count || 0,
      isMember: !!ch.is_member,
      archived: !!ch.archived,
    }));
    return [general, ...rest];
  };

  const refetch = useCallback(async () => {
    try {
      const res = await fetch(`/api/channels?circle_id=${circleId}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        setError(res.status);
        setLoading(false);
        return;
      }
      const data = await res.json();
      setChannels(normalize(data));
      setCanManage(!!data.can_manage);
      setError(null);
      setLoading(false);
    } catch (e) {
      setError('network');
      setLoading(false);
    }
  }, [circleId]);

  useEffect(() => {
    if (!circleId) return;
    refetch();
  }, [circleId, refetch]);

  // チャンネルを開いたら未読表示をローカルで消灯する（BE側の既読化Jobと並行）
  const markChannelRead = useCallback((key) => {
    setChannels((prev) =>
      prev.map((ch) =>
        ch.key === key
          ? { ...ch, hasUnread: false, unreadMentionCount: 0 }
          : ch,
      ),
    );
  }, []);

  return { channels, canManage, loading, error, refetch, markChannelRead };
}
